import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../images/logo-white.png";

import { footerLinks } from "../../utils/data";

// Create a mapping function for footer links
const getLinkPath = (category, section, item) => {
  const linkMap = {
    Company: {
      About: {
        Leadership: "/about#leadership",
        Press: "/about#press",
      },
      Support: {
        Contact: "/contact",
        "Help Center": "/help",
        Security: "/security",
        Compliance: "/compliance",
      },
      Legal: {
        "Terms of Service": "/terms",
        "Privacy Policy": "/privacy",
        "Regulatory Disclosures": "/disclosures",
        "Cookie Policy": "/cookies",
      },
    },
  };

  return linkMap[category]?.[section]?.[item] || "#";
};

const Footer = () => {
  return (
    // Footer Section
    <Container fluid className="footer-container position-relative mt-5 p-0">
      <div className="footer-content py-5 position-relative z-2">
        <Container>
          <Row className="g-4">
            <Col lg={4} className="mb-4 mb-lg-0">
              <div className="footer-brand">
                <Link to="/" className="text-decoration-none ">
                  <div className="d-flex gap-2 align-items-center mb-3">
                    <img src={Logo} alt="Logo" width={180} height="80" />
                  </div>
                </Link>
              </div>
              <p className="text-muted mb-4">
                The most trusted cryptocurrency platform for trading, staking,
                and earning.
              </p>
            </Col>
            {Object.entries(footerLinks).map(([category, sections], index) => (
              <Col lg={4} key={index} className="mb-4 mb-lg-0">
                <div className="footer-section">
                  <h5 className="section-title">{category}</h5>
                  <div className="footer-grid">
                    {Object.entries(sections).map(([title, items], i) => (
                      <div key={i} className="footer-column">
                        <h6>{title}</h6>
                        <ul className="list-unstyled footel-links-content">
                          {items.map((item, j) => (
                            <li key={j} className="footel-link-item">
                              <Link
                                to={getLinkPath(category, title, item)}
                                className="footer-link"
                              >
                                {item}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <div className="footer-bottom mt-5 pt-4">
            <Row className="align-items-center">
              <Col md={6} className="mb-3 mb-md-0">
                <p className="mb-0 text-muted">
                  ©Copyright 2019 Airclift Capital.{" "}
                  <Link
                    to="https://aircliftcapital.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary"
                  >
                    Airclift Capital
                  </Link>{" "}
                </p>
              </Col>
              <Col md={6} className="text-md-end">
                <div className="language-selector">
                  <select className="form-select w-auto mx-auto ms-md-auto me-lg-0 form-select-sm">
                    <option value="en">English</option>
                  </select>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </Container>
  );
};
export default Footer;
